import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const CheckCircle: FC<SvgIconProps> = (props) => (
  <SvgIcon width="24" height="24" {...props}>
    <path
      fillRule="evenodd"
      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0 2c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M18.707 8.207L10 16.914l-4.207-4.207 1.414-1.414L10 14.086l7.293-7.293 1.414 1.414z"
      clipRule="evenodd"
    />
  </SvgIcon>
)
